export const getAddDef = (text:any) =>{
    return (
    [
        {"value":"_year","text":text.year},
        {"value":"_personBirthWarekiGengou","text":`${text.birthDay}:${text.gengou}`},
        {"value":"_personBirthWarekiYear","text":`${text.birthDay}:${text.warekiNen}`},
        {"value":"_personBirthMonth","text":`${text.birthDay}:${text.month}`},
        {"value":"_personBirthDay","text":`${text.birthDay}:${text.day}`},
        {"value":"_personIsEnterYear","text":text.isEnterYear},
        {"value":"_personEnterShorWarekiYear","text":`${text.enter}:${text.warekiShortNen}`},
        {"value":"_personEnterMonth","text":`${text.enter}:${text.month}`},
        {"value":"_personEnterDay","text":`${text.enter}:${text.day}`},
        {"value":"_personIsRetireYear","text":text.isRetireUear},
        {"value":"_personRetireShorWarekiYear","text":`${text.retire}:${text.warekiShortNen}`},
        {"value":"_personRetireMonth","text":`${text.retire}:${text.month}`},
        {"value":"_personRetireDay","text":`${text.retire}:${text.day}`},
        {"value":"_month","text":text.month},
        {"value":"_name","text":text.userName},
        {"value":"_pcode","text":text.pCode},
        {"value":"_warekiNen","text":text.warekiNen},
        {"value":"_SpouseName","text":text.administrator.spouse.name},
        {"value":"_SpouseKana","text":text.administrator.spouse.kana},
        {"value":"_SpouseLiving","text":text.administrator.spouse.living},
        {"value":"_DependentChild1_Name","text":`${text.administrator.dependentChild.name} 1`},
        {"value":"_DependentChild1_Kana","text":`${text.administrator.dependentChild.kana} 1`},
        {"value":"_DependentChild1_Living","text":`${text.administrator.dependentChild.living} 1`},
        {"value":"_DependentChild2_Name","text":`${text.administrator.dependentChild.name} 2`},
        {"value":"_DependentChild2_Kana","text":`${text.administrator.dependentChild.kana} 2`},
        {"value":"_DependentChild2_Living","text":`${text.administrator.dependentChild.living} 2`},
        {"value":"_DependentChild3_Name","text":`${text.administrator.dependentChild.name} 3`},
        {"value":"_DependentChild3_Kana","text":`${text.administrator.dependentChild.kana} 3`},
        {"value":"_DependentChild3_Living","text":`${text.administrator.dependentChild.living} 3`},
        {"value":"_DependentChild4_Name","text":`${text.administrator.dependentChild.name} 4`},
        {"value":"_DependentChild4_Kana","text":`${text.administrator.dependentChild.kana} 4`},
        {"value":"_DependentChild4_Living","text":`${text.administrator.dependentChild.living} 4`},
        {"value":"_DependentOther1_Name","text":`${text.administrator.dependentOther.name} 1`},
        {"value":"_DependentOther1_Kana","text":`${text.administrator.dependentOther.kana} 1`},
        {"value":"_DependentOther1_Living","text":`${text.administrator.dependentOther.living} 1`},
        {"value":"_DependentOther2_Name","text":`${text.administrator.dependentOther.name} 2`},
        {"value":"_DependentOther2_Kana","text":`${text.administrator.dependentOther.kana} 2`},
        {"value":"_DependentOther2_Living","text":`${text.administrator.dependentOther.living} 2`},
        {"value":"_DependentOther3_Name","text":`${text.administrator.dependentOther.name} 3`},
        {"value":"_DependentOther3_Kana","text":`${text.administrator.dependentOther.kana} 3`},
        {"value":"_DependentOther3_Living","text":`${text.administrator.dependentOther.living} 3`},
        {"value":"_DependentOther4_Name","text":`${text.administrator.dependentOther.name} 4`},
        {"value":"_DependentOther4_Kana","text":`${text.administrator.dependentOther.kana} 4`},
        {"value":"_DependentOther4_Living","text":`${text.administrator.dependentOther.living} 4`},
    ]);
}